import type {OwnerReadModelSnapshot} from './product-types';
import {Hint,V3Card} from './owner-v3-ui';

/** The Pad's last capacity report, never an estimate of ingredient inventory. */
export function OwnerCapacity({snapshot}:{snapshot:OwnerReadModelSnapshot|null}){
  const capacity=snapshot?.capacity;
  const current=Boolean(capacity&&capacity.businessDate===snapshot?.store?.businessDate);
  return <V3Card title="店內餘量" aside={<span>{capacity?current?'今日讀回':'舊營業日資料':'未有讀回'}</span>}>
    {!capacity?<Hint>尚未收到店內 Pad 的容量資料，不能確認剩餘份數。</Hint>:<>
      <Hint>營業日 {capacity.businessDate} · 最後回報 {new Intl.DateTimeFormat('zh-HK',{timeZone:'Asia/Hong_Kong',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hour12:false}).format(new Date(capacity.observedAt))}。按門店設定計算；不同商品每件用量可以不同。{!current?'不是今日容量，請在店內核對。':''}</Hint>
      {capacity.pools.length?capacity.pools.map(pool=><div className="v3-list-row" key={pool.poolId}><span><strong>{pool.name}</strong><small>每日設定 {pool.dailyQty} 份 · 今日總額度 {pool.todayTotal} 份</small><small>自家渠道{pool.firstPartyAccepting?'容量允許接單':'容量已停接'} · 外賣平台{pool.thirdPartyAccepting?'容量允許接單':'容量已停接'}</small></span><b>餘 {pool.remainingQty} 份</b></div>):<Hint>此營業日未有啟用容量池。</Hint>}
      {capacity.invalidActivePoolIds.length?<Hint>有 {capacity.invalidActivePoolIds.length} 項容量設定需要在店內核對。</Hint>:null}
    </>}
  </V3Card>;
}
